import { SUSPENSE_COMPETITOR, SUSPENSE_REASON } from '../../../../../../views/billing/subscription/constants';

export default {
  title: 'Automatische Abrechnung',
  buttons: {
    add_subscription: 'Abonnement hinzufügen',
    suspend_company: 'Restaurant kündigen',
    restore_company: 'Restaurant wiederherstellen',
    edit_suspend: 'Aussetzungsinformationen bearbeiten',
    confirm: 'Bestätigen',
    cancel: 'Abbrechen',
  },
  modals: {
    suspend_company: {
      title: 'Sind Sie sicher, dass Sie {{company}} kündigen wollen?',
      description:
        'Dies wird alle aktiven Abonnements kündigen, laufende Bestellungen deaktivieren und den Restaurantbesitzer per E-Mail über die Kündigung informieren. Bitte wählen Sie einen Grund aus, bevor Sie bestätigen.',
      suspense_reason: {
        label: 'Grund für die Aussetzung auswählen',
        placeholder: 'Wählen Sie einen Grund',
        options: {
          [SUSPENSE_REASON.ClosedOrOwnershipChange]: 'Geschlossen oder Eigentümerwechsel',
          [SUSPENSE_REASON.LowRoi]: 'Geringer ROI',
          [SUSPENSE_REASON.PricingFeesSensitivity]: 'Preis-/Gebührenempfindlichkeit',
          [SUSPENSE_REASON.MissingIntegrationsProductGaps]: 'Fehlende Integrationen/Produktlücken',
          [SUSPENSE_REASON.PoorOnboardingActivation]: 'Schlechte Einführung/Aktivierung',
          [SUSPENSE_REASON.SupportDissatisfaction]: 'Unzufriedenheit mit dem Support',
          [SUSPENSE_REASON.SwitchedToCompetitor]: 'Wechsel zu Konkurrent/Marktplatz/DIY',
          [SUSPENSE_REASON.MarketingPerformanceDisappointment]: 'Enttäuschung über die Marketing-Performance',
          [SUSPENSE_REASON.WrongRegistrationData]: 'Wrong Registration / Data',
        },
        validation: {
          required: 'Bitte wählen Sie einen Grund aus',
        },
      },
      suspense_competitor: {
        label: 'Zu welchem Wettbewerber sind sie gewechselt?',
        placeholder: 'Bitte wählen Sie einen Wettbewerber',
        options: {
          [SUSPENSE_COMPETITOR.Allo]: 'Allo',
          [SUSPENSE_COMPETITOR.Sides]: 'Slice',
          [SUSPENSE_COMPETITOR.Ordersmart]: 'Ordersmart',
          [SUSPENSE_COMPETITOR.RobinCook]: 'Robin Cook',
          [SUSPENSE_COMPETITOR.Lightspeed]: 'Lightspeed',
          [SUSPENSE_COMPETITOR.GastroMaster]: 'Gastro Master',
          [SUSPENSE_COMPETITOR.Dish]: 'Dish',
          [SUSPENSE_COMPETITOR.Other]: 'Andere',
        },
        validation: {
          required: 'Bitte wählen Sie einen Wettbewerber aus',
        },
      },
      suspense_reason_notes: {
        label: 'Zusätzlicher Kontext (optional)',
        placeholder: 'Geben Sie weitere Details an',
      },
    },
    restore_company: {
      title: 'Sind Sie sicher, dass Sie {{company}} wiederherstellen wollen?',
      description: 'Sie müssen weiterhin manuell ein Abonnement erstellen und Live-Aufträge aktivieren.',
    },
  },
  toasts: {
    failed_to_load_data: 'Abonnementdetails konnten nicht geladen werden',
    failed_to_suspend_company:
      'Das Restaurant konnte nicht gesperrt werden. Bitte kontaktieren Sie den technischen Support',
    failed_to_restore_company:
      'Das Restaurant konnte nicht wiederhergestellt werden. Bitte kontaktieren Sie den technischen Support',
  },
};
